import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatMonth'
})
export class FormatMonth implements PipeTransform {

    transform(value: any, args: any[]): string {
        let months = [
            'Janeiro',
            'Fevereiro',
            'Março',
            'Abril',
            'Maio',
            'Junho',
            'Julho',
            'Agosto',
            'Setembro',
            'Outubro',
            'Novembro',
            'Dezembro'
        ];
        return months[value-1]?months[value-1]:"--";
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/format-month.pipe.ts